import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OnDestroyHookDirective } from '../../common/hooks';
import {
  getBufferedArrayFor,
  saveDocument,
} from '../../services/save-document.service';
import { FileDownloaderService } from '../../services/file-downloader.service';

@Component({
  selector: 'my-bill-odb-download-csv',
  templateUrl: './odb-download-csv.component.html',
  standalone: false,
})
export class OdbDownloadCsvComponent extends OnDestroyHookDirective {
  @Input() documentReference: string;
  @Input() billingAccountNumber: string;
  @Input() linkLabel = 'bills.redesign.downloadCard.downloadCsvLinkLabel';
  @Input() buttonZone = 'mybill.detail';
  @Input() dataCy = 'myBillOdbCoverExportAsCSVButton';
  @Input() customerId?: number;
  @Output() downloadFileError: EventEmitter<{
    hasCsvError: boolean;
    invoiceError?: boolean;
  }> = new EventEmitter();
  isDownloadInProgress = false;

  constructor(private fileDownloaderService: FileDownloaderService) {
    super();
  }

  downloadCsv() {
    this.isDownloadInProgress = true;

    this.addSubscription(
      this.fileDownloaderService
        .getCallDetailsFile({
          paId: this.billingAccountNumber,
          documentId: this.documentReference,
          cdbid: this.customerId,
        })
        .subscribe((response) => {
          if (response.hasError) {
            this.isDownloadInProgress = false;
            this.downloadFileError.emit({
              hasCsvError: true,
              invoiceError: false,
            });
            return;
          }
          if (response.filecontent) {
            saveDocument(
              getBufferedArrayFor(response.filecontent),
              this.documentReference + '.csv',
              'text/csv'
            );
            this.downloadFileError.emit({
              hasCsvError: false,
              invoiceError: false,
            });
          }
          this.isDownloadInProgress = false;
        })
    );
  }
}
